import React, {Component} from "react";
import styles from "./styles/KingstonConnect.scss";
import axios from 'axios';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

export default class SignIn extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: undefined,
      password: undefined,
      errorMsg: undefined,
      saving: false,
    }
  }

  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  signIn = (e) => {
    e.preventDefault();
    this.setState({ saving: true })
    axios.post(
      "/api/kingstonconnect/signin", {
        data: this.state
    })
    .then(res => {
      this.setState({ saving: false })
      let result = res.data.success;
      console.log(res.data.employer)
      if (result === true) {
        if (res.data.employer.active) {
          sessionStorage.setItem('employer', res.data.employer._id)
          sessionStorage.setItem('name', res.data.employer.first_name)
          sessionStorage.setItem('loggedIn', true);
          window.location.reload()
        } else {
          this.setState({
            errorMsg: "Admin Approval is required to access the portal."
          });
        }
      }
    })
    .catch(err => {
      this.setState({ saving: false });
      console.log(err)
      this.setState({
        errorMsg: "The email or password may not be correct."
      });
    });
  }

  render() {
    return(
      <div className={styles.login}>
        <div className="form-group">

          <form onSubmit={this.signIn}>
            <div className="">
              <div className="form-group col-6 offset-3">

                <label>Email</label>
                <input onChange={this.handleChange} name="email" required className="form-control" />
                <br/>
                <label>Password</label>
                <input onChange={this.handleChange} name="password" type="password" required className="form-control" />

              </div>
              {this.state.errorMsg &&
                <div className="alert alert-danger" role="alert">
                <strong>Uh oh!</strong>{' ' + this.state.errorMsg}
                </div>
              }
            </div>
            <button className="btn btn-primary">
              {"Login "}
              {this.state.saving &&
                <FontAwesomeIcon spin
                icon={faSpinner}
                />
              }
            </button>
          </form>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/pages/KingstonConnect/SignIn.js